module.exports = __webpack_public_path__ + "static/media/tree9.da598501.png";